/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Stack, Fade, Text, Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import useRegistrationFields from '../../components/forms/useRegistrationFields'
import Field from '../field'
import PasswordRequirements from '../../components/forms/password-requirements'
import {FormattedMessage} from 'react-intl'
import {useBrand} from '../../contexts/brand-context'
import useHideLoyaltyUIForInternational from '@app/hooks/use-hide-loyalty-ui-for-international'

const RegistrationFields = ({form, prefix = ''}) => {
    const {isGarage} = useBrand()
    const fields = useRegistrationFields({form, prefix})
    const password = form.watch(`${prefix}password`)
    const shouldHideLoyaltyUI = useHideLoyaltyUIForInternational()

    return (
        <Stack spacing={4}>
            <Stack spacing={2}>
                <Field {...fields.email} />
                <Field {...fields.password} />
                <PasswordRequirements value={password} />
                <Field
                    {...fields.phone}
                    iconProps={{
                        display: 'none'
                    }}
                />
                <Field {...fields.birthDay}/>
                {!shouldHideLoyaltyUI && (
                    <Text
                        fontSize="12px"
                        color="webTypo.textSecondary"
                        fontWeight="normal"
                        mb="3"
                        lineHeight="1.5"
                    >
                        {isGarage ? (
                            <FormattedMessage
                                id="login_birthday.loyalty.gift.garage"
                                defaultMessage="Add your birthday to get a special gift every year! You cannot change it afterwards."
                            />
                        ) : (
                            <FormattedMessage
                                id="login_birthday.loyalty.gift.dynamite"
                                defaultMessage="Add your birthday to get a special gift every year! You cannot change it afterwards."
                            />
                        )}
                    </Text>
                )}
            </Stack>

            <Field {...fields.termsAndConditions} />
            <Field {...fields.emailSubscribe} />
        </Stack>
    )
}

RegistrationFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default RegistrationFields
